import {
  COMPROBAR_ARTICULOS_REPOSICIONES_STOCK, GENERAR_CSV_ARTICULOS_REPOSICIONES,
  GENERAR_PEDIDO_GW1,
  GET_ARTICULOS_REPOSICIONES,
  GET_ARTICULOS_REPOSICIONES_REQUEST,
  INICIAR_MODULO_REPOSICIONES_NEWCO, REPOSICIONES_SET_RANGO_FECHAS, REPOSICIONES_SET_SEARCH_TEXT,
  SELECCIONAR_TIPO_ARTICULO,
  SET_FILTER,
  SET_PAGINATION_REPOSICION,
  SET_SELECTED_ARTICULOS_REPOSICION,
  SET_UNIDADES_ARTICULO_REPOSICION,
} from '../constants/newCo.reposiciones.constants';

export const setSelectedArticulosReposicion = (type, record, selected) => ({
  type: SET_SELECTED_ARTICULOS_REPOSICION,
  payload: { type, record, selected },
});
export const setPaginationReposicion = pagination => ({
  type: SET_PAGINATION_REPOSICION,
  payload: pagination,
});
export const setUnidadesArticuloReposicion = data => ({
  type: SET_UNIDADES_ARTICULO_REPOSICION,
  payload: data,
});
export const iniciarModuloReposiciones = payload => ({
  type: INICIAR_MODULO_REPOSICIONES_NEWCO,
  payload,
});
export const getArticulosReposiciones = payload => ({
  type: GET_ARTICULOS_REPOSICIONES,
  payload,
});
export const comprobarArticulosReposicionesStock = () => ({
  type: COMPROBAR_ARTICULOS_REPOSICIONES_STOCK,
});
export const generarPedidoGw1 = () => ({
  type: GENERAR_PEDIDO_GW1,
});
export const setFilter = (payload, esPropiedades = false) => ({
  type: SET_FILTER,
  payload: { ...payload, esPropiedades },
});
export const seleccionarTipoArticulo = tipo => ({
  type: SELECCIONAR_TIPO_ARTICULO,
  payload: tipo,
});
export const generarCsvArticulos = () => ({
  type: GENERAR_CSV_ARTICULOS_REPOSICIONES,
});

export const setSearchText = text => ({
  type: REPOSICIONES_SET_SEARCH_TEXT,
  payload: text,
});
export const setRangoFechas = rangoFechas => ({
  type: REPOSICIONES_SET_RANGO_FECHAS,
  payload: rangoFechas,
});
